// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 多样性枚举 枚举类
 * 多样性枚举
 */
export enum EnumMultiplicity {
  /** 0...1 : 零个或者一个 */
  ZeroOne = 1,
  /** 1 : 一个 */
  One = 2,
  /** 0...* : 零个或多个 */
  ZeroMany = 4,
  /** 1...* : 一个或多个 */
  OneMany = 8
}

/**
 * 多样性枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumMultiplicityMD {
  private static items = [
    new EnumItemMD('ZeroOne', 1, '0...1', '零个或者一个'),
    new EnumItemMD('One', 2, '1', '一个'),
    new EnumItemMD('ZeroMany', 4, '0...*', '零个或多个'),
    new EnumItemMD('OneMany', 8, '1...*', '一个或多个')
  ];

  static getItem(enumItem: EnumMultiplicity) {
    return this.items.find(item => item.name === EnumMultiplicity[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
